import { useMemo } from "react";
import { useAppSelector } from "../useReduxHooks";
import { selectUseLoyaltyService } from "../../redux/selectors/loyaltyServiceSelectors";
import { LocalizedString } from "../../redux/types/CartLoyaltyV2Types";
import { OrderTypesEnum } from "../../../utils/enums";
import {
  getLoyaltyChannel,
  mapToLoyaltyOrderType,
} from "../../../utils/LoyaltyUtils/loyaltyMapper";

export const useLoyaltyContext = () => {
  const useLoyaltyService = useAppSelector(selectUseLoyaltyService);
  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);
  const selectedFranchise = useAppSelector(
    (state) => state.config.selectedFranchise
  );
  const selectedLanguage = useAppSelector(
    (state) => state.config.selectedLanguage
  );
  const orderTypeParam = useAppSelector(
    (state) => state.queryParams.orderTypeParam
  );

  const timeZone =
    selectedFranchise?.timeZone ?? restaurantInfo?.timeZone ?? "UTC";
  const mappedOrderType = mapToLoyaltyOrderType(
    orderTypeParam as OrderTypesEnum
  );
  const channel = getLoyaltyChannel();
  const lang = selectedLanguage as keyof LocalizedString;

  return useMemo(
    () => ({
      useLoyaltyService,
      timeZone,
      mappedOrderType,
      channel,
      lang,
      selectedFranchiseId: selectedFranchise?.id,
      restaurantId: restaurantInfo?.id,
    }),
    [
      useLoyaltyService,
      timeZone,
      mappedOrderType,
      channel,
      lang,
      selectedFranchise?.id,
      restaurantInfo?.id,
    ]
  );
};
